module.exports = __webpack_public_path__ + "5e1b8d7aa39766d620958091771d717c.webp";